var chunkMapping = {
	"0": [
		0
	],
	"252": [
		252
	],
	"313": [
		2313
	],
	"596": [
		6596
	],
	"611": [
		4611
	],
	"666": [
		6666
	],
	"735": [
		3735
	],
	"759": [
		2759
	],
	"866": [
		3866
	],
	"977": [
		8977
	]
};
var idToExternalAndNameMapping = {
	"0": [
		"default",
		"./YlNuvei3ds",
		3078
	],
	"252": [
		"default",
		"./CookieBanner",
		329
	],
	"2313": [
		"default",
		".",
		8562
	],
	"2759": [
		"default",
		"./YlDoku3ds",
		4888
	],
	"3735": [
		"default",
		"./YlStripe3ds",
		3309
	],
	"3866": [
		"default",
		"./YlBraintree3ds",
		8388
	],
	"4611": [
		"default",
		"./ChatLoader",
		4736
	],
	"6596": [
		"default",
		"./YlSony3ds",
		3266
	],
	"6666": [
		"default",
		"./YlChat",
		9447
	],
	"8977": [
		"default",
		"./YlCybersource3ds",
		1134
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_modules__[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}